import embedUrl from './embedUrl';
import htmlVideo from './htmlVideo';

export {
  embedUrl,
  htmlVideo,
};
